module.exports = __webpack_public_path__ + "img/tip.728b0129.png";